import React, { forwardRef, InputHTMLAttributes, ReactNode } from 'react';
import { Checkbox } from '../Checkbox';
import { useChecklistContext } from './checklist.context';
import styles from './styles.module.css';

export interface CheckrowProps
  extends Omit<
    InputHTMLAttributes<HTMLInputElement>,
    'id' | 'type' | 'checked'
  > {
  id: string;
  label: string;
  icon?: ReactNode;
  style?: React.CSSProperties;
  crossedOutWhenChecked?: boolean;
}

export const Checkrow = forwardRef<HTMLInputElement, CheckrowProps>(
  ({ id, label, icon, ...inputProps }, ref) => {
    const { checkedItems, toggleItem, variant } = useChecklistContext();
    const isChecked = checkedItems[id] || false;

    return (
      <div className={styles.checkrow} style={inputProps.style}>
        {icon && <div className={styles.icon}>{icon}</div>}
        <div
          className={`${styles.label} ${
            isChecked && inputProps.crossedOutWhenChecked
              ? styles.crossedOut
              : ''
          }`}
        >
          {label}
        </div>
        <div className={styles.checkboxWrapper}>
          <Checkbox
            id={`checkbox-${id}`}
            checked={isChecked}
            setChecked={() => toggleItem(id)}
            variant={variant}
            ref={ref}
            sameColorAsTheCrossedOutLabel={inputProps.crossedOutWhenChecked}
            {...inputProps}
          />
        </div>
      </div>
    );
  }
);

Checkrow.displayName = 'Checkrow';
